export const GOOGLE_FORM_ACTION =
  'https://docs.google.com/forms/d/e/1FAIpQLSeTqpPnowCAvOd1gXDr-lcMLjDYgAFwV2LIogauj67WkAHIWg/formResponse';

export const RECORDING_FEEDBACK_FORM_ENTRIES = {
  chatWillingness: 'entry.814526467',
  companySize: 'entry.208370486',
  email: 'entry.1879456210',
  role: 'entry.185775267',
  tools: 'entry.209884383',
  useCase: 'entry.508402476',
  website: 'entry.813462129',
} as const;

export type RecordingFeedbackFormPayload = {
  chatWillingness: string;
  companySize: string;
  role: string;
  roleOther: string;
  tools: readonly string[];
  toolsOther: string;
  useCase: string;
  useCaseOther: string;
  website: string;
};

export const postToGoogleForm = async (email: string, values: RecordingFeedbackFormPayload): Promise<void> => {
  const form = new FormData();

  form.set(RECORDING_FEEDBACK_FORM_ENTRIES.email, email);

  form.set(RECORDING_FEEDBACK_FORM_ENTRIES.role, values.role);
  if (values.role === '__other_option__' && values.roleOther.trim()) {
    form.set(`${RECORDING_FEEDBACK_FORM_ENTRIES.role}.other_option_response`, values.roleOther.trim());
  }

  form.set(RECORDING_FEEDBACK_FORM_ENTRIES.companySize, values.companySize);

  if (values.website.trim()) {
    form.set(RECORDING_FEEDBACK_FORM_ENTRIES.website, values.website.trim());
  }

  form.set(RECORDING_FEEDBACK_FORM_ENTRIES.useCase, values.useCase);
  if (values.useCase === '__other_option__' && values.useCaseOther.trim()) {
    form.set(`${RECORDING_FEEDBACK_FORM_ENTRIES.useCase}.other_option_response`, values.useCaseOther.trim());
  }

  for (const tool of values.tools) {
    form.append(RECORDING_FEEDBACK_FORM_ENTRIES.tools, tool);
  }
  if (values.tools.includes('__other_option__') && values.toolsOther.trim()) {
    form.set(`${RECORDING_FEEDBACK_FORM_ENTRIES.tools}.other_option_response`, values.toolsOther.trim());
  }

  form.set(RECORDING_FEEDBACK_FORM_ENTRIES.chatWillingness, values.chatWillingness);

  try {
    await fetch(GOOGLE_FORM_ACTION, { body: form, method: 'POST', mode: 'no-cors' });
  } catch {}
};
